export const BNK_STMT_updatebsSuccessReducer = {
  BNK_STMT_updatebsSuccess: (state, action) => {
    state.bsSuccess = action.payload;
  },
};
